import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { LearmoStoreModule } from './shared/store/store.module';

import { errorInterceptor } from './interceptors/error.interceptor';
import { jwtInterceptor } from './interceptors/jwt.interceptor';
import { cookieInterceptor } from './interceptors/cookie.interceptor';

import { VersionCheckService } from './shared/services/version-check.service';
import { CustomNgbModalService } from './shared/services/custom-ngbmodal.service';
import { CanDeactivateDashboardGuard } from './shared/guards/dashboardnav.guard';

import { FullComponent } from './shared/layout/full/full.component';
import { NewVersionAnnouncementComponent } from './shared/layout/owner-dashboard/new-version-announcement/new-version-announcement.component';
import { SocketStatusComponent } from './shared/layout/owner-dashboard/socker-status/socket-status.component';
import { PlaygroundComponent } from './components/playground/playground.component';

import { PortalViewModule } from './components/user-dashboard/portal/view/portal-view.module';
import { ContactsModule } from './components/user-dashboard/contacts/contacts.module';
import { AiModule } from './features/ai/ai.module';
import { ListsModule } from './features/lists/lists.module';
import { MessengerModule } from './features/messenger/messenger.module';
import { WizardModule } from './features/wizard/wizard.module';
import { MediaLibraryModule } from './features/media-library/media-library.module';

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    NewVersionAnnouncementComponent,
    SocketStatusComponent,
    PlaygroundComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    CoreModule,
    AppRoutingModule,
    SharedModule,
    LearmoStoreModule,
    PortalViewModule,
    ContactsModule,
    ListsModule,
    AiModule,
    MessengerModule,
    WizardModule,
    MediaLibraryModule,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([jwtInterceptor, cookieInterceptor, errorInterceptor])
    ),
    CanDeactivateDashboardGuard,
    VersionCheckService,
    CustomNgbModalService,
    { provide: NgbModal, useExisting: CustomNgbModalService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
